import { render, staticRenderFns } from "./NavBarMenu.vue?vue&type=template&id=37e10b71&scoped=true"
import script from "./NavBarMenu.vue?vue&type=script&lang=js"
export * from "./NavBarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e10b71",
  null
  
)

export default component.exports